import React, { useEffect, useReducer, useState } from "react";
import {
  DataGrid,
  Column,
  Selection,
  Paging,
  Pager,
  SearchPanel,
  HeaderFilter,
  Toolbar,
  Item,
} from "devextreme-react/data-grid";
import * as actions from "../../actions/settings";
import settingsReducer from "../../reducers/settings";
import _ from "lodash";
import { useParams } from "react-router-dom";

const initialState = { tiersData: [], reasonsTier: null };

export default (props) => {
  const { site } = useParams();
  const [state, dispatch] = useReducer(settingsReducer, initialState);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const { reasonsTier } = state;

  useEffect(() => {
    const fetchData = async () => {
      if (props.data.key && props.data.key.length !== 36) {
        await actions.fetchRSTiers(dispatch, `${site}&reasonid=${props.data.key}`);
      }
    };
    fetchData();
  }, [props.data.key, site]);

  useEffect(() => {
    if (reasonsTier && reasonsTier.length > 0) {
      const selectedTiers = reasonsTier.filter(d => d.isActive).map(d => d.tierID);
      setSelectedRowKeys(selectedTiers);
    }
  }, [reasonsTier]);

  const onSelectionChanged = (e) => {
    const newSelectedRowKeys = e.selectedRowKeys;
    if (!_.isEqual(selectedRowKeys, newSelectedRowKeys)) {
      setSelectedRowKeys(newSelectedRowKeys);
      const tierIds = newSelectedRowKeys.map((d) => ({ tierIds: d }));
      const payload = { reasonId: props.data.key, reasonTierData: tierIds };
      actions.saveTiersForReason(dispatch, payload);
    }
  };

  return (
    <>
      {reasonsTier && (
        <DataGrid
          dataSource={reasonsTier}
          showBorders={true}
          columnAutoWidth={true}
          keyExpr="tierID"
          allowColumnReordering={true}
          selectedRowKeys={selectedRowKeys}
          onSelectionChanged={onSelectionChanged}
        >
          <Selection
            mode="multiple"
            showCheckBoxesMode="always"
            selectAllMode="page"
          />
          <SearchPanel visible={true} />
          <HeaderFilter visible={true} />
          <Paging defaultPageSize={10} />
          <Pager
            visible={true}
            allowedPageSizes={[10, 20, 50]}
            showPageSizeSelector={true}
            showInfo={true}
            showNavigationButtons={true}
          />
          <Toolbar>
            <Item location="before">
              <div className="informer">
                <span className="name">Reasoncodes Tier Data</span>
              </div>
            </Item>
            <Item name="searchPanel" visible={true} />
          </Toolbar>
          <Column dataField="tierID" width="30%" />
          <Column dataField="tierName" width="60%" />
        </DataGrid>
      )}
    </>
  );
};
